import { createSelector } from 'reselect';
import { 
// Frame
hasUserSelector, } from '@xingternal/platform-layout-selectors';
const sideBarSelector = createSelector(hasUserSelector, (hasUser) => {
    return {
        hasUser,
    };
});
export { sideBarSelector };
//# sourceMappingURL=side-bar.selector.js.map